import { Button, EmptyState, Heading, Modal, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { useContext } from "react"
import { Link } from "react-router-dom"
import { PayrollContext } from "../../../contexts/PayrollContext/PayrollContext"
import { companyUnpaidInvoicesPath } from "@oysterhr/invoicing"
import { useAccountAspect } from "@oysterhr/identity"

interface Props {
  onClose: () => void
}

export const PayrollChangeRestrictedModal = ({ onClose }: Props) => {
  const { t } = useTranslation("Payroll")
  const { companyId } = useContext(PayrollContext)
  const { isStaff } = useAccountAspect()
  const aspect = isStaff ? "staff" : "customer"

  return (
    <Modal isOpen onRequestClose={onClose}>
      <Modal.Header>
        <div className="flex flex-col items-center gap-2">
          <img
            src={EmptyState.Illustration.secure1}
            className="w-12"
            alt={t(`restrictions.addPayrollChangeModal.${aspect}.title`)}
          />
          <Heading size="xl" className="text-center">
            {t(`restrictions.addPayrollChangeModal.${aspect}.title`)}
          </Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <Text>{t(`restrictions.addPayrollChangeModal.${aspect}.content`)}</Text>
      </Modal.Content>
      <Modal.Footer>
        <Button as={Link} to={companyUnpaidInvoicesPath({ companyId, isStaff })}>
          {t("restrictions.addPayrollChangeModal.viewUnpaidInvoices")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
